import type { PersonalDetailsDto } from '../../models/person/personalDetailsDto';
import type { EducationalDetailsDto } from '../../models/person/educationalDetailsDto';
import type { PCSDetailsDto } from '../../models/pcsEnrolment/pcsDetailsDto';
import { requests } from '../httpClient';

export const Pcs = {
    getCurrentYearAsync: () => requests.get(`PCS/CurrentYear`),
    getRegistrationDetailsAsync: () => requests.get(`PCS`),
    getCanEnrolAsync: () => requests.get(`PCS/CanEnrol`),
    getCanReEnrolAsync: () => requests.get(`PCS/CanReEnrol`),
    getCreditSummaryAsync: () => requests.get(`PCS/Summary`),
    saveRegistrationDetailsAsync: (data: PCSDetailsDto) => requests.put(`PCS/RegistrationDetails`, data),
    submitPersonalDetailsAsync: (data: PersonalDetailsDto) => requests.put(`PCS/PersonalDetails`, data),
    updateEducationAsync: (data: EducationalDetailsDto) => requests.put(`PCS/Education`, data)
};
